/** @jsx jsx */
import React from "react";
import { jsx } from "@emotion/core";
export const Astronaut2 = React.forwardRef<
  SVGSVGElement,
  Omit<React.SVGProps<SVGSVGElement>, "css">
>((props, ref) => (
  <svg
    viewBox="0 0 132 132"
    ref={ref}
    css={{
      color: "#F4F6F8",
      height: "132px",
      width: "132px",
    }}
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <circle cx={66} cy={66} r={66} fill="currentColor" />
      <g
        stroke="#464646"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
      >
        <path
          fill="#F18686"
          d="M60.31 78.179h8.363c1.154 0 2.091 1 2.091 2.23v3.903c0 1.231-.937 2.23-2.09 2.23H60.31c-1.155 0-2.091-.999-2.091-2.23V80.41c0-1.23.936-2.23 2.09-2.23z"
        />
        <path d="M82.526 86.543V80.53a9.015 9.015 0 0 0-6.49-8.656 3.503 3.503 0 0 1-2.527-3.366v-6.012a9.018 9.018 0 0 0-18.035 0v6.012c0 1.558-1.03 2.93-2.526 3.364a9.015 9.015 0 0 0-6.49 8.656v6.012" />
        <path d="M55.474 62.497l3.323-1.661a12.728 12.728 0 0 1 11.39 0l3.322 1.661m-18.035 6.012l3.323 1.66a12.728 12.728 0 0 0 11.39 0l3.322-1.66M46.457 80.531V67.006a4.508 4.508 0 0 1 4.509-4.509m31.56 18.034V67.006a4.508 4.508 0 0 0-4.509-4.509m-10.52-21.04v6.012m-3.006-3.006h6.012m18.034 12.023v6.011m-3.006-3.006h6.012" />
        <path
          fill="#74B0F4"
          d="M81.48 41.196a7.378 7.378 0 0 1-7.318 7.318 7.378 7.378 0 0 1 7.318 7.318 7.378 7.378 0 0 1 7.318-7.318 7.378 7.378 0 0 1-7.318-7.318"
        />
      </g>
      <path
        fill="#CAD0D8"
        d="M88 107c.581 0 1.053.509 1.053 1.137l-.001 1.81h1.812c.627 0 1.136.471 1.136 1.053 0 .581-.509 1.053-1.136 1.053l-1.812-.001v1.812c0 .627-.47 1.136-1.052 1.136-.581 0-1.053-.509-1.053-1.136v-1.812h-1.81c-.628 0-1.137-.47-1.137-1.052 0-.582.509-1.053 1.136-1.053h1.811v-1.81c0-.628.472-1.137 1.053-1.137zM26 91c.581 0 1.053.509 1.053 1.137l-.001 1.81h1.812c.627 0 1.136.471 1.136 1.053 0 .581-.509 1.053-1.136 1.053l-1.812-.001v1.812c0 .627-.47 1.136-1.052 1.136-.581 0-1.053-.509-1.053-1.136v-1.812h-1.81c-.628 0-1.137-.47-1.137-1.052 0-.582.509-1.053 1.136-1.053h1.811v-1.81c0-.628.472-1.137 1.053-1.137zm11-76c.581 0 1.053.509 1.053 1.137l-.001 1.81h1.812c.627 0 1.136.471 1.136 1.053 0 .581-.509 1.053-1.136 1.053l-1.812-.001v1.812c0 .627-.47 1.136-1.052 1.136-.581 0-1.053-.509-1.053-1.136v-1.812h-1.81c-.628 0-1.137-.47-1.137-1.052 0-.582.509-1.053 1.136-1.053h1.811v-1.81c0-.628.472-1.137 1.053-1.137z"
      />
      <circle cx={74.5} cy={97.5} r={1.5} fill="#CAD0D8" />
      <circle cx={47.5} cy={105.5} r={1.5} fill="#CAD0D8" />
      <circle cx={110.5} cy={90.5} r={1.5} fill="#CAD0D8" />
      <circle cx={29.5} cy={48.5} r={1.5} fill="#CAD0D8" />
      <circle cx={108.5} cy={45.5} r={1.5} fill="#CAD0D8" />
      <circle cx={20.5} cy={72.5} r={1.5} fill="#CAD0D8" />
      <circle cx={102.5} cy={29.5} r={1.5} fill="#CAD0D8" />
      <circle cx={59.5} cy={7.5} r={1.5} fill="#CAD0D8" />
      <circle cx={55.5} cy={32.5} r={1.5} fill="#CAD0D8" />
      <g transform="translate(55 118)">
        <circle cx={2.5} cy={2.5} r={2.5} fill="#CAD0D8" />
        <circle cx={2.5} cy={2.5} r={1} fill="currentColor" />
      </g>
      <g transform="translate(104 66)">
        <circle cx={2.5} cy={2.5} r={2.5} fill="#CAD0D8" />
        <circle cx={2.5} cy={2.5} r={1} fill="currentColor" />
      </g>
      <g transform="translate(10 49)">
        <circle cx={2.5} cy={2.5} r={2.5} fill="#CAD0D8" />
        <circle cx={2.5} cy={2.5} r={1} fill="currentColor" />
      </g>
      <g transform="translate(76 10)">
        <circle cx={2.5} cy={2.5} r={2.5} fill="#CAD0D8" />
        <circle cx={2.5} cy={2.5} r={1} fill="currentColor" />
      </g>
    </g>
  </svg>
));
